import { render, staticRenderFns } from "./product-cost.vue?vue&type=template&id=12521155"
import script from "./product-cost.vue?vue&type=script&lang=js"
export * from "./product-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports